import http from '@/plugins/axios/axios';

export default class RevendedorService {

    salvar(requisicao) {       
        return http.post('/api/adm/revendedor/salvar', requisicao);
    } 

    excluir(requisicao) {       
        return http.post('/api/adm/revendedor/excluir', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/adm/revendedor/listar', requisicao);
    } 

    listarTodos(requisicao) {       
        return http.post('/api/adm/revendedor/listar-todos', requisicao);
    } 

    listarClientes(requisicao) {       
        return http.post('/api/adm/revendedor/listar-clientes', requisicao);
    } 

    login(revendedor) {
        return http.post('/api/adm/revendedor/login', revendedor);
    }

    solicitarRedefinirSenha(dados) {
        return http.post('/api/adm/revendedor/solicitar-redefinir-senha', dados);
    }

    validarTokenRedefinirSenha(dados) {
        return http.post('/api/adm/revendedor/validar-token-redefinir-senha', dados);
    }

    validarCodigoRedefinirSenha(dados) {
        return http.post('/api/adm/revendedor/validar-codigo-redefinir-senha', dados);
    }

    alterarSenha(dados) {
        return http.post('/api/adm/revendedor/alterar-senha', dados);
    }
}